<template>
  <div class="body">
    <div class="tab-nav-container" v-if="isShowNavBar">
      <div class="top-nav-bar">
        <div class="back-btn" @click="onGoBack">
          <Icon name="arrow-left"></Icon>
        </div>
        <div class="top-container">
          <div class="title-info-container">
            {{navTitle}}
          </div>
        </div>
        <div class="right-btn">
          <div class="action">
            <div class="desc">自动购买</div>
            <van-switch v-model="checkedAuto" active-color="#A6A6A6" inactive-color="#f2f2f2" size="16px"></van-switch>
          </div>
        </div>
      </div>
    </div>
    <LoadingComponent v-if="!preloadSuccess"></LoadingComponent>
    <div v-if="preloadSuccess">
      <list v-model="isLoadingRecord"
            :finished="dataLoadingFinished"
            offset="0"
            @load="loadRecordData"
            :key="listKeyRefresh"
      >
        <div v-for="articleRecord in articleRecordList" :key="articleRecord.id" class="content-div-container" @click.self="onClickImg">
          <div class="title-div">{{articleRecord.title}}</div>
          <div v-if="showNeedAuth(articleRecord)">
            <div class="article-container-part">
              <div v-if="articleRecord.image_urls" class="img-preview">
                <img class="img-comic" v-for="(imgUrl, idx) in articleRecord.image_urls" :src="imgUrl" :key="idx"
                     @click="onClickImg"/>
              </div>

              <div class="chapter-charge">
                <div class="base-info-desc">
                  <div class="info-item">本章解锁: <span class="figure">{{articleRecord.credit}}</span>币</div>
                </div>

                <div class="exchange-btn-container">

                  <div class="auto-exchange">
                    <Checkbox v-model="checkedAuto" checked-color="#ee0a24">书币充足时自动购买，不再提示</Checkbox>
                  </div>
                  <Button class="button-exchange" @click="onExchangeArticleRecord(articleRecord.id)"
                          :loading="loadingExchange">
                    {{articleRecord.credit}}币解锁本话
                  </Button>
                  <Button class="button-exchange" @click="onExchangeNovelPartial(articleRecord)"
                          :loading="loadingExchangeNovelPartial"
                          v-if="showExchangePartial(articleRecord)">
                    <div class="btn-txt">特惠批量解锁章节
                      <icon-svg icon-class="tehui" class="exchange-tehui-icon"></icon-svg>
                    </div>
                  </Button>
                  <Button class="button-exchange" v-if="showExchangeBook(articleRecord)" @click="onExchangeNovelBook()"
                          :loading="loadingExchangeNovelBook">
                    特惠订阅全本
                    <icon-svg icon-class="tehui" class="exchange-tehui-icon"></icon-svg>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div class="article-container" v-else :key="articleRecord.id">
            <div v-if="articleRecord.image_urls">
              <img class="img-comic" v-for="(imgUrl, idx) in articleRecord.image_urls" :src="imgUrl" :key="idx"
                   @click="onClickImg"/>
            </div>
          </div>
        </div>
      </list>

      <Checkbox v-model="checkedAuto" @change="onChangeAuto" style="display: none;"></Checkbox>
      <NovelBookShelf :item="itemInfo" ref="bookShelf"></NovelBookShelf>
    </div>

    <div v-if="showNextPage" class="next-page-container">
      <Button @click="onClickNextPage" class="next-btn" round type="warning">下一页</Button>
    </div>

    <Popup v-model="showArticleList" position="left">
      <div class="popup-container">
        <List v-model="loadingArticleRecordList"
              :finished="loadingArticleRecordListFinished"
              finished-text=" "
              @load="onLoadArticleRecordList" v-if="showArticleList">
          <Cell
              v-for="item in listChapter"
              :key="item"
              class="cell-item" @click="onSwitchArticleRecordPage(item)">
            <div :class="['cell-content-text', item=== (currentPage)?'emph':'']">第{{item}}节</div>
          </Cell>
        </List>
      </div>
    </Popup>

    <div class="bottom-bar-fix" v-if="isShowNavBar">
      <div class="bottom-action-container">
        <div class="item-container">
          <div class="back-btn-inline" @click="onToHome">
            <icon-svg icon-class="home"></icon-svg>
          </div>
          <div class="back-btn-inline" @click="showList">
            <icon-svg icon-class="menu"></icon-svg>
          </div>
          <div class="next-page-btn-container" @click="onClickPrevPage">
            <icon-svg icon-class="arrow-left-line"></icon-svg>
          </div>
          <div class="next-page-btn-container" @click="onClickNextPage">
            <div class="txt">下一页</div>
            <icon-svg icon-class="arrow-right-line"></icon-svg>
          </div>
          <div class="settings-item-box" @click="onAddToShelf" v-if="showAddToShelf">
            <div class="txt" v-if="showAddToShelf">加入书架</div>
            <icon-svg icon-class="add-bookshelf" v-if="showAddToShelf"></icon-svg>
            <icon-svg icon-class="done" v-else></icon-svg>
          </div>
        </div>
      </div>
    </div>

    <DonatePopup v-model="showDonatePopup" :refer="itemId" v-if="itemId" scene="comic"></DonatePopup>
    <ItemActionStatsEmit :delay="3000" action="view" :itemId="itemId" itemType="comic"
                         :articleRecordId="articleRecordList[articleRecordList.length-1].id" :page="currentPage"
                         :key="currentPage"
                         v-if="currentPage && articleRecordList && articleRecordList.length > 0 && itemId && !isLoadingRecord"></ItemActionStatsEmit>
    <div class="empty-div"></div>
  </div>

</template>

<script>
  import {Toast, Button, Pagination, Icon, Loading, Notify, Popup, List, Cell, Dialog, Checkbox, Switch} from "vant"
  import TopNavbar from "../../common/TopNavbar";
  import ItemActionStatsEmit from "../../common/ItemActionStatsEmit";
  import DonatePopup from "../../common/DonatePopup";
  import LoadingComponent from "../../common/LoadingComponent";
  import NovelBookShelf from "../../common/NovelBookShelf";

  export default {
    name: "ComicArticleRecord",
    components: {
      NovelBookShelf,
      LoadingComponent,
      DonatePopup,
      ItemActionStatsEmit, TopNavbar, Toast, Pagination, Loading, Icon, Button, Popup, List, Cell,
      Checkbox,  [Switch.name]: Switch,
    },
    data() {
      return {
        itemId: 0,
        userId: 0,
        preloadSuccess: false,
        articleRecordList: [],
        showDonatePopup: false,

        isLoadingRecord: false,
        dataLoadingFinished: false,
        currentPage: 1,
        nextPage: 1,
        totalPageCount: 0,
        lastReadPage: 0,
        checkedAuto: false,

        itemInfo: null,
        showArticleList: false,
        listChapter: [],

        loadingArticleRecordList: false,
        loadingArticleRecordListFinished: false,

        loadingExchange: false,
        loadingExchangeNovelBook: false,
        loadingExchangeNovelPartial: false,

        listKeyRefresh: 0,
        showNextPage: false,

        exchangeBookConfig: {},

        prevScrollpos: 0,
        showNavBar: true,

        showAddToShelf: false,
        listTypeBookShelf: "book_shelf",

        refer: "wt_app",
      }
    },
    mounted() {
      this.itemId = this.$route.params.id
      let page = this.$route.query.page
      if (!page) {
        this.currentPage = 1
        this.nextPage = 1
      } else {
        this.currentPage = parseInt(page)
        this.nextPage = parseInt(page)
      }

      this.initItemInfo()
      this.initUserInfo()
      this.prevScrollpos = window.pageYOffset;
      window.addEventListener('scroll', this.handleScroll);
    },

    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
      init() {
        this.articleRecordList = []
        this.backTop()
        this.dataLoadingFinished = false
        this.showNextPage = false
        this.showArticleList = false
        this.listKeyRefresh += 1
        this.showNavBar = true
      },

      async initItemInfo() {
        await this.loadItemInfo()
        if (this.lastReadPage) {
          this.currentPage = this.lastReadPage
          this.nextPage = this.lastReadPage
        }

        this.preloadSuccess = true
      },

      initUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          if (data && data.id) {
            this.userId = data.id
          }
        }, () => {
        })
      },

      onToHome() {
        this.$router.push("/_tab_comic")
      },

      onGoBack() {
        this.$router.go(-1)
      },

      handleScroll() {
        let currentScrollPos = window.pageYOffset;
        if (currentScrollPos < 50) {
          this.showNavBar = true
        } else {
          if (this.prevScrollpos > currentScrollPos) {
            // this.showNavBar = true
          } else {
            this.showNavBar = false
          }
        }
        this.prevScrollpos = currentScrollPos;
      },

      onClickImg() {
        this.showNavBar = !this.showNavBar
      },


      onChangeAuto() {
        if (this.checkedAuto) {
          this.$refs.bookShelf.onClickAddCustom("auto_exchange")
        } else {
          this.$refs.bookShelf.onClickRemoveCustom("auto_exchange")
        }
      },

      onLoginSuccess() {
      },

      checkClear() {
        if (this.articleRecordList.length > 20 && this.dataLoadingFinished === false) {
          this.showNextPage = true
          this.dataLoadingFinished = true
        }
      },

      showExchangePartial(articleRecord) {
        if (articleRecord && articleRecord.id > 0 && articleRecord.show_exchange_partial) {
          return true
        } else {
          return false
        }
      },

      showExchangeBook(articleRecord) {
        if (articleRecord && articleRecord.id > 0 && articleRecord.show_exchange_full) {
          return true
        } else {
          return false
        }
      },

      onAddToShelf() {
        let action = "add"
        let actionName = "加入书架"
        if (!this.showAddToShelf) {
          action = "remove"
          actionName = "移出书架"
        }
        let params = {
          item_id: this.itemId,
          action: action,
          list_type: this.listTypeBookShelf,
        }
        this.showAddToShelf = !this.showAddToShelf
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
            Toast(actionName)
          } else if (data.code === 20010) {
            this.$router.push("/login")
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网络异常")
        })
      },

      showList() {
        this.showArticleList = true
      },

      async loadRecordData() {
        let params = {
          "item_id": this.itemId,
          "page": this.nextPage,
        }
        this.currentPage = this.nextPage
        this.nextPage = this.currentPage + 1
        await this.$store.dispatch("GetArticleRecordByPage", params).then((data) => {
          if (data.code === 0) {
            this.articleRecordList.push(data.data)

            let extra = data.extra
            this.totalPageCount = extra.total_count

            if (this.showNeedAuth(data.data)) {
              this.dataLoadingFinished = true
            }

            if (!extra.has_more) {
              this.dataLoadingFinished = true
            }
            this.isLoadingRecord = false
          } else {
            if (data.code === 10014) {
              this.nextPage = 1
            }
            Toast("请求错误")
            this.dataLoadingFinished = true
            this.isLoadingRecord = false
          }
        }).catch(() => {
          Toast("网络异常")
        })

        this.checkClear()
        this.emitItemViewAction(this.currentPage)
      },

      onClickNextPage() {
        this.onSwitchArticleRecordPage(this.currentPage + 1)
      },

      onClickPrevPage() {
        this.onSwitchArticleRecordPage(this.currentPage - 1)
      },

      backTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },

      async doExchange(itemId, itemType, page) {
        let params = {
          item_id: '' + itemId,
          item_type: itemType,
        };
        if (page) {
          params.page = parseInt(page)
        }
        this.loadingExchange = true
        await this.$store.dispatch("ExchangeCredit", params).then((data) => {
          if (data.code === 0) {
            this.nextPage = this.currentPage
            this.init()
          } else if (data.code === 20010) {
            this.$router.push("/login")
          } else if (data.code === 30001) {
            this.showDonatePopup = true
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网络错误")
        })
        this.loadingExchange = false
      },

      onExchangeArticleRecord(recordId) {
        this.doExchange(recordId, "article_record")
      },

      async onExchangeNovelPartial(articleRecord) {
        let params = {
          "item_id": this.itemId,
          "page": articleRecord.chapter_id,
        }
        console.log(params)
        this.loadingExchangeNovelPartial = true
        await this.$store.dispatch("GetNovelCredit", params).then((data) => {
          if (data.code === 0) {
            let creditCount = data.data.credit
            let articleRecordCount = data.data.article_record_count
            let creditCountPrev = data.data.credit_prev
            let isNew = data.data.is_new_user_promote
            let title = isNew ? '新人特惠' : ''

            Dialog.confirm({
              title: title,
              message: `${creditCount} 书币解锁此后 ${articleRecordCount} 章内容
(原价${creditCountPrev}书币)`,
              confirmButtonColor: "#fc9153",
            }).then(() => {
              this.doExchange(this.itemId, "comic_book", articleRecord.chapter_id)
            }).catch(() => {
            });
          } else if (data.code === 20010) {
            this.$router.push("/login")
          }
        })
        this.loadingExchangeNovelPartial = false
      },

      async onExchangeNovelBook(articleRecord) {  // 订阅（包括更新）
        let params = {
          "item_id": this.itemId
        }
        this.loadingExchangeNovelBook = true
        await this.$store.dispatch("GetNovelCredit", params).then((data) => {
          if (data.code === 0) {
            let creditCount = data.data.credit
            let articleRecordCount = data.data.article_record_count
            let bookStatus = data.data.book_status

            let title = "解锁全文"
            let message = `${creditCount} 书币兑换剩余${articleRecordCount}章节`
            if (bookStatus === 1) {
              title = `${creditCount} 书币订阅整本`
              message = `解锁${articleRecordCount}话 以及后续连载更新`
            }

            Dialog.confirm({
              title: title,
              message: message,
              confirmButtonColor: "#fc9153",
            }).then(() => {
              this.doExchange(this.itemId, "comic_book")
            }).catch(() => {
            });
          } else if (data.code === 20010) {
            this.$router.push("/login")
          }
        })
        this.loadingExchangeNovelBook = false
      },

      onSwitchArticleRecordPage(page) {
        if (!this.userId) {
          this.$router.push("/login")
          return;
        }

        if (page > this.totalPageCount) {
          Toast("已到最后一页")
          return
        }

        if (page <= 0) {
          Toast("已到首页")
          return
        }

        this.nextPage = parseInt(page)
        this.showArticleList = false
        this.init()
      },

      async loadItemInfo() {
        let params = {
          "id": this.itemId,
        }
        await this.$store.dispatch("GetUgcItem", params).then((data) => {
          if (data.code === 0) {
            this.itemInfo = data.data
            if (this.itemInfo && this.itemInfo.item_list && this.itemInfo.item_list.book_shelf) {
              this.showAddToShelf = false
            } else {
              this.showAddToShelf = true
            }

            this.checkedAuto = this.checkIsAutoExchange(this.itemInfo)
            if (this.itemInfo && this.itemInfo.last_read_page) {
              this.lastReadPage = this.itemInfo.last_read_page
            }
          } else {
          }
        }, (err) => {
        })
      },

      checkIsAutoExchange(item) {
        if (!item || !item.item_list) {
          return false
        }
        if (!item.item_list.auto_exchange) {
          return false
        } else {
          return true
        }
      },

      onLoadArticleRecordList() {
        let params = {
          "id": this.itemId,
        }
        this.$store.dispatch("GetUgcItem", params).then((data) => {
          if (data.code === 0) {
            let totalCount = data.data.article_record_count
            let l = []
            for (let i = 1; i <= totalCount; i++) {
              l.push(i)
            }
            this.listChapter = l
          } else {
          }

          this.loadingArticleRecordList = false
          this.loadingArticleRecordListFinished = true
        }, (err) => {
          Toast("网络错误")
        })
      },

      showNeedAuth(articleRecord) {
        if (articleRecord && articleRecord.id > 0 && !articleRecord.is_auth) {
          return true
        } else {
          return false
        }
      },

      emitItemViewAction(page) {
        let params = {
          "item_id": parseInt(this.itemId),
          "page": page,
          "refer": this.refer,
          "action": "view",
        }
        this.$store.dispatch("DoItemAction", params)
      }
    },
    computed: {
      navTitle() {
        if (this.articleRecordList && this.articleRecordList.length > 0) {
          return this.articleRecordList[this.articleRecordList.length - 1].title
        } else {
          return ""
        }
      },

      isShowNavBar() {
        if (this.dataLoadingFinished || (this.showNavBar && this.preloadSuccess && !this.isLoadingRecord)) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .body {
    min-height: 100vh;
    background: white;
  }

  .tab-nav-container {
    position: fixed;
    width: 100%;
    z-index: 1000;
    left: 0;
    top: 0;

    .top-nav-bar {
      position: relative;
      background: white;
      top: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #f2f2f2;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;

      .top-container {
        overflow: hidden;
        position: relative;
        max-width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        margin: 0 auto;
      }

      .back-btn {
        color: #fc9153;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        height: 44px;
        padding: 0 15px;
        position: absolute;
        left: 0;
      }

      .right-btn {
        position: absolute;
        color: rgb(166, 166, 166);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        right: 0;
        height: 44px;
        padding: 0 15px;

        .action {
          display: flex;
          align-items: center;

          .desc {
            margin-right: 5px;
          }

        }

      }
    }
  }

  .img-comic {
    width: 100%;
    display: block;
  }

  .article-container {
  }

  .title-div {
    border-top: 1px solid #f2f2f2;
    text-align: center;
    color: grey;
    font-size: 16px;
    padding: 10px 0;
  }

  .article-container-part {
    position: relative;
    margin-bottom: 25px;

    .img-preview {
      max-height: 230px;
      overflow: hidden;
    }
  }

  .bottom-bar-fix {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: white;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .bottom-action-container {
    color: #666;
    padding: 18px 18px;
    font-size: 16px;
    border-top: 1px solid #f2f2f2;

    .item-container {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    .next-page-btn-container {
      display: flex;
      align-items: center;
      justify-content: center;

      .next-page-btn {
        font-size: 18px;
      }
    }

    .back-btn-inline {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .settings-item-box {
      display: flex;
      align-items: center;
      justify-content: center;

      .txt {
        margin-right: 5px;
      }
    }
  }

  .chapter-charge {
    margin: 0 12px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 12px;
    background: white;
    color: #585e66;
    padding: 8px 12px;
    /*padding: .4rem 0;*/
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);

    .base-info-desc {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 0;
      border-bottom: 1px solid #f2f2f2;
      font-size: 16px;

      .figure {
        color: grey;
        padding: 0 1px;
        font-weight: bold;
      }
    }

    .exchange-btn-container {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      padding: 12px 12px;

      .auto-exchange {
        padding: 8px 0;
        color: #323233;
      }


      .button-exchange {
        color: rgba(75, 75, 75, 0.89);
        background: rgba(213, 214, 209, 0.33);
        min-width: 75%;
        font-size: 14px;
        line-height: 1.5;
        margin-top: 8px;

        .btn-txt {
          display: flex;
          align-items: center;

          .exchange-tehui-icon {
            font-size: 24px;
            margin-left: 5px;
          }
        }
      }
    }
  }

  .my-content {
    padding: 5px;
  }

  .need-unlock-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    .mask {
      height: 220px;
      width: 100%;
      background: linear-gradient(0, rgb(255, 255, 255), rgb(255, 255, 255, 0));
    }
  }

  .content-div-container {
    min-height: 100vh;
  }

  .loading-info {
    position: fixed;
    width: 100%;
    height: 100vh;
    z-index: 5;
  }

  .loading-spinner {
    position: fixed;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .button-container {
    font-size: 12px;
    padding: 15px 15px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;

    .button-item-large {
      width: 39%;
      margin: 5px;
    }

    .button-item-small {
      width: 32%;
      margin: 5px;
    }
  }

  .empty-div {
    width: 100%;
    height: 125px;
  }

  .pagination {
    margin: 0 15px;
  }

  .popup-container {
    width: 150px;
    height: 100vh;
  }

  .cell-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 125px;

    .emph {
      font-weight: bold;
      color: rgba(255, 0, 0, 0.76);
    }

    .cell-content-text {
      text-align: center;
    }
  }

  .article-record-list-btn {
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    position: fixed;
    z-index: 100;
    right: 15px;
    bottom: 85px;
    background-color: rgba(128, 128, 128, 0.42);
    color: #ffffff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .next-page-container {
    padding: 12px 24px 32px;
    text-align: right;

    .next-btn {
      width: 55%;
    }
  }

  .popup-exchange {
    width: 80%;

    .popup-exchange-container {
      padding: 25px 15px;

      .title-container {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
      }

      .radio-container {
        font-size: 14px;
        color: grey;
        margin-top: 15px;

        .radio-item {
          margin-top: 5px;
          padding: 8px 6px;
          border: solid 1px #f2f2f2;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
        }

        .selected {
          border: solid 1px rgba(255, 148, 122, 0.69);
        }

      }

      .btn-container {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .exchange-btn {
          width: 35%;
        }
      }
    }
  }

  .popup-settings {
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .font-size-settings {
      width: 50%;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }

  .pay-card-container {
    margin-top: 15px;
    margin-bottom: 15px;
    border-top: 1px solid #f2f2f2;
    background: white;
    -webkit-border-radius: 18px 18px 0 0;
    -moz-border-radius: 18px 18px 0 0;
    border-radius: 18px 18px 0 0;

    .title {
      margin-top: 12px;
      font-size: 14px;
      text-align: center;
    }
  }
</style>
